import { render, staticRenderFns } from "./BankAbbrev.vue?vue&type=template&id=2596eaa8&"
import script from "./BankAbbrev.vue?vue&type=script&lang=js&"
export * from "./BankAbbrev.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports